module.exports = __webpack_public_path__ + "img/SHOP_UK_Kits_Square_Stand_2nd-Gen_Kit_Gallery.07de3c71.webp";